import {
  SET_GENERATED_LINEUP_COUNT,
  SET_LINEUP_SAVED_FLAG,
  SET_SAVED_LINEUP_COUNT,
} from "./Lineup";

export const initial_lineup_information = {
  lineup_saved_flag: false,
  generated_lineup_count: 0,
  saved_lineup_count: 0,
};

const lineupReducer = (state = initial_lineup_information, action) => {
  console.log("###############  Lineup Reducer  ###############");
  console.log("Action: ", action);
  console.log("State: ", state);
  switch (action.type) {
    case SET_LINEUP_SAVED_FLAG:
      return {
        ...state,
        lineup_saved_flag: action.lineup_saved_flag,
      };
    case SET_GENERATED_LINEUP_COUNT:
      return {
        ...state,
        generated_lineup_count: action.generated_lineup_count,
      };
    case SET_SAVED_LINEUP_COUNT:
      return {
        ...state,
        saved_lineup_count: action.saved_lineup_count,
      };

    default:
      return state;
  }
};

export default lineupReducer;
